import { LoggingService } from "../loggingSvc";
import { ServiceDeskConfig } from "../../Startup/serviceDeskConfig";
import { AgentProfileEntity } from "../entity-service-implementation/agent-profile-entity-model";
import { MsalAuthenticationServiceImplementation } from "../msal/msal-authentication-service";

export interface AgentProfileContractApp {
  code: string;
  message: string;
}
export interface GraphApiService {
  getAgentProfile(): ng.IPromise<AgentProfileEntity>;
  getUserProfileImage(): ng.IPromise<any>;
}
export class GraphApiServiceImplementation implements GraphApiService {
  private agentProfile: AgentProfileEntity = undefined;
  public graphResource: string = "";
  public graphApiProfileApiUrl = "";
  public graphApiImageApiUrl = "";
  public graphScopes: string[] = [];

  // @ngInject
  constructor(
    private loggingService: LoggingService,
    private $http: ng.IHttpService,
    private msalAuthenticationService: MsalAuthenticationServiceImplementation,
    private $q: ng.IQService,
    private sdConfig: ServiceDeskConfig
  ) {
    this.graphResource = this.sdConfig.getGraphApiResource();
    this.graphScopes = [this.graphResource + "/.default"];
    this.graphApiProfileApiUrl = this.graphResource + "/v1.0/me";
    this.graphApiImageApiUrl = this.graphResource + "/v1.0/me/photo/$value";
  }
  public getAgentProfile(): ng.IPromise<AgentProfileEntity> {
    return this.msalAuthenticationService.acquireTokenSilent(this.graphScopes).then(
      (data: string) => {
        return this.getAgentProfileFromGraph(data);
      },
      (response: ng.IHttpPromiseCallbackArg<{}>) => {
        this.loggingService.logError({
          message: "Could not get access token for graph api resource",
          response: response,
          aadUser: this.msalAuthenticationService.userInfo
        });
        return this.$q.reject(response);
      }
    );
  }

  getUserProfileImage(): ng.IPromise<any> {
    if (!this.sdConfig.isSecretCloud) {
      return this.msalAuthenticationService._getCachedToken(this.graphScopes).then((token) => {
        if (token) {
          return this.getAgentImageFromGraph(token);
        }

        return this.msalAuthenticationService.acquireTokenSilent(this.graphScopes).then((data: string) => {
          if (data !== null && data !== undefined) {
            return this.$http
              .get(this.graphApiImageApiUrl, <any>{
                serviceName: "CST",
                headers: { Authorization: "Bearer " + data },
                responseType: "blob"
              })
              .then((result: any) => {
                if (result !== undefined && result !== null && result.status === 200) {
                  return result.data;
                } else {
                  this.loggingService.logError(result.statusText);
                  return this.$q.reject(result.statusText);
                }
              });
          }
        });
      });
    }
    return null;
  }
  private getAgentProfileFromGraph(token: string): ng.IPromise<AgentProfileEntity> {
    return this.$http
      .get(this.graphApiProfileApiUrl, <any>{
        serviceName: "CST",
        headers: { Authorization: "Bearer " + token }
      })
      .then(
        (response: any) => {
          return this.mapToAgentProfileEntityModel(response.data);
        },
        (response: ng.IHttpPromiseCallbackArg<{}>) => {
          this.loggingService.logError({
            message: "Could not find graph profile for logged in user",
            response: response,
            aadUser: this.msalAuthenticationService.userInfo
          });
          if (response.data) {
            return this.mapToAgentProfileEntityModel(response.data);
          }
          return this.$q.reject(response);
        }
      );
  }
  private mapToAgentProfileEntityModel(response: any): AgentProfileEntity {
    this.agentProfile = {
      aadUpn: this.msalAuthenticationService.userInfo.idToken.preferred_username,
      msaPuid: "",
      encryptedPuid: null,
      sipAddress: "",
      email: response.mail,
      firstName: response.givenName,
      lastName: response.surname,
      siteId: "",
      siteName: "",
      supplierName: "",
      supportedChannels: [],
      extensionProperties: null,
      tier: "",
      isSfbEnabled: false,
      supportedLocales: [],
      supportAreaPaths: [],
      id: response.id,
      name: response.givenName,
      createdDateTime: null,
      lastModifiedDateTime: null,
      createdBy: "",
      lastModifiedBy: "",
      isActive: true,
      versionNumber: "",
      type: "Agent",
      imageUrl: this.graphResource + `/v1.0/me/photo/$value`
    };
    return this.agentProfile;
  }

  private getAgentImageFromGraph(token: string): ng.IPromise<AgentProfileEntity> {
    return this.$http
      .get(this.graphApiImageApiUrl, <any>{
        serviceName: "CST",
        headers: { Authorization: "Bearer " + token }
      })
      .then(
        (response: any) => {
          if (response !== undefined && response !== null && response.data !== undefined && response.data !== null) {
            return response.data;
          } else {
            this.loggingService.logError(response.statusText);
            return this.$q.reject(response.statusText);
          }
        },
        (response: ng.IHttpPromiseCallbackArg<{}>) => {
          this.loggingService.logError({
            message: "Could not find graph profile image for logged in user",
            response: response,
            aadUser: this.msalAuthenticationService.userInfo
          });
          return this.$q.reject(response);
        }
      );
  }
}
